// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"991e0407","777":"81c0a512","845":"2c777d69"}[chunkId] + ".chunk.js";
};